import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=6f87f1de&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=ts&"
export * from "./HelloWorld.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./HelloWorld.vue?vue&type=style&index=0&id=6f87f1de&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6f87f1de",
  null
  ,true
)

export default component.exports